import AcBackToTopButton from '../AcBackToTopButton/AcBackToTopButton';
import AcHorizontalSeparator from '../AcHorizontalSeparator/AcHorizontalSeparator';
import './HowToSyncBody.scss'
import HowToSyncBodyAccountDetails from './HowToSyncBodyAccountDetails';
import HowToSyncBodyFirstSteps from './HowToSyncBodyFirstSteps';
import SupportPageHelpSection from './SupportPageHelpSection';

export default function HowToSyncBody() {
    return (
        <div className='hts-body__container'>
            <AcBackToTopButton />
            <div className='hts-body__data'>
                <div className='hts-body__left-section'>
                    <HowToSyncBodyFirstSteps />
                    <AcHorizontalSeparator />                  
                    <HowToSyncBodyAccountDetails />                    
                </div>
                <div className='hts-body__right-section'>
                    <SupportPageHelpSection />
                </div>
            </div>
        </div>
    )
}
